import { IPatient } from '@pia/pia.shared';
import { IPatientListFilter } from '../contracts/filter/patient-list-filter';
import { IPatientListFilterArgs } from '../contracts/filter/patient-list-filter-args';
import { LastVisitChoice } from 'src/app/patient/components/patient-list/patient-list-filter/patient-list-filter.component';

export class PatientListFilter implements IPatientListFilter {
  constructor(
    public readonly filterArgs: IPatientListFilterArgs = {},
    readonly lastVisit: LastVisitChoice = LastVisitChoice.anyTime,
    public readonly showDisabledPatients?: boolean,
    public readonly therapyId?: number,
    public readonly therapyTypeId?: number,
    public readonly payerType?: number,
    public readonly payerId?: string
  ) {}

  public hasAnySettings() {
    return (
      this.hasAnyFilterArgs() ||
      this.showDisabledPatients ||
      this.lastVisit != LastVisitChoice.anyTime ||
      this.therapyId != null ||
      this.therapyTypeId != null ||
      this.payerType != null ||
      this.payerId != null
    );
  }

  public filterPatients(patients: IPatient[], callbackFn: (patients: IPatient[]) => IPatient[]): IPatient[] {
    for (const [key, value] of Object.entries(this.filterArgs || {})) {
      if (!value) {
        continue;
      }

      if (key === 'fieldNurseId') {
        patients = patients.filter(
          patient =>
            patient[key] === value ||
            (patient.additionalUserIds ? patient['additionalUserIds']?.indexOf(value) !== -1 : false)
        );
        continue;
      }

      patients = patients.filter(
        patient => (key === 'subunitId' ? patient.nursingHome.subunitId : patient[key]) === value
      );
    }

    if (!this.showDisabledPatients) {
      patients = callbackFn(patients);
    }
    return patients;
  }

  public hasAnyFilterArgs(): boolean {
    return Object.values(this.filterArgs || {}).some(value => Boolean(value));
  }

  public hasOnlyShowDisabledPatientsOrLastVisitFilter(): boolean {
    return (
      (this.showDisabledPatients ||
        this.lastVisit != LastVisitChoice.anyTime ||
        this.therapyId != null ||
        this.therapyTypeId != null ||
        this.payerType != null ||
        this.payerId != null) &&
      !this.hasAnyFilterArgs()
    );
  }

  public hasMultipleFilter(): boolean {
    if (!this.hasAnyFilterArgs()) {
      return false;
    }
    const hasMultiple = Object.values(this.filterArgs || {}).filter(value => Boolean(value)).length > 1;
    return hasMultiple;
  }

  public getCurrentFilterFieldName(): string {
    if (this.hasMultipleFilter()) {
      return 'multiple';
    }
    const filterArgs = this.filterArgs || {};
    const fieldName = Object.keys(filterArgs).filter(key => Boolean(filterArgs[key]))[0];
    return fieldName ? fieldName : '';
  }

  public isReferenceEqual(filter: IPatientListFilter): boolean {
    return this === filter;
  }
}
